import React, { useEffect, useState } from 'react';
import { useForm } from 'react-hook-form';
import { useSelector } from 'react-redux';
import { selectUser } from 'redux/slices/userSlice';
import { yupResolver } from '@hookform/resolvers';
import { useTranslation } from 'react-i18next';
import * as yup from 'yup';
import { RequiredString } from 'helpers/yupHelper';
import { useHistory, useParams } from 'react-router-dom';
import { getCompanies } from 'services/rest/SuperAdmin/Company/getCompanies';
import { ErrorAlert } from 'components/Alert';
import {
  AgentData,
  updateAgent
} from 'services/rest/SuperAdmin/Agents/updateAgent';
import { getAgentById } from 'services/rest/SuperAdmin/Agents/getAgentById';
import UpdateAgentForm from './UpdateAgentForm';

interface Option {
  value: number;
  label: string;
}

const UpdateAgent: React.FC = () => {
  const { t } = useTranslation(['super_admin_agent', 'validations']);
  const userSchema = yup.object().shape({
    name: RequiredString().max(70, t('validations:length_error', { max: 70 })),
    email: RequiredString().max(
      100,
      t('validations:length_error', { max: 100 })
    )
  });

  const { register, control, handleSubmit, setValue, errors } = useForm({
    resolver: yupResolver(userSchema)
  });
  const { currentUser } = useSelector(selectUser);
  const { token, role } = currentUser;
  const [companies, setCompanies] = useState<Array<any>>([]);
  const [selectedCompanies, setSelectedCompanies] = useState<Option[]>([]);
  const [loader, setLoader] = useState(false);
  const { agentId } = useParams<any>();
  const [loading, setLoading] = useState<boolean>(true);
  const [agent, setAgent] = useState<any>();
  const [error, setError] = useState<string>('');
  const history = useHistory();

  const onSubmit = async (agentData: AgentData) => {
    setLoader(true);
    const { data, errors } = await updateAgent(
      agentId,
      token,
      agentData,
      selectedCompanies
    );
    if (data) {
      setLoader(false);
      if (data?.errors) {
        setError(data.errors?.data);
      } else {
        history.push('/agents', t('super_admin_agent:update_success'));
      }
    }
    if (errors) {
      setError(errors?.data);
      setLoader(false);
    }
  };

  const getAgentData = async () => {
    const { data: agentData } = await getAgentById(token, agentId);
    const { data: companiesData } = await getCompanies(token, 500, 1);

    if (agentData && companiesData) {
      setAgent(agentData);
      setCompanies(companiesData);
      setSelectedCompanies(agentData.companies);
      setLoading(false);
    }
  };

  useEffect(() => {
    getAgentData();
  }, []);
  return (
    <>
      {error && (
        <ErrorAlert
          text={error}
          allowClose={true}
          onClose={() => setError('')}
        />
      )}
      <UpdateAgentForm
        onSubmit={handleSubmit(onSubmit)}
        register={register}
        agent={agent}
        errors={errors}
        setValue={setValue}
        control={control}
        loader={loader}
        companies={companies}
        loading={loading}
        selectedCompanies={selectedCompanies}
        setSelectedCompanies={setSelectedCompanies}
      />
    </>
  );
};

export default UpdateAgent;
